/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type { BrowserHistory } from 'history/createBrowserHistory';

import CentralForm from 'components/CentralForm/CentralForm.js';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';
import { PasswordModel, EmailModel } from 'models/AccountModels';

import { DoublePassword } from './DoublePassword';

type TypeWithEmailModel = {| emailModel: EmailModel |};
type TypePropsChangePassword = {|
  passwordModel: PasswordModel,
  history: BrowserHistory,
|} & TranslatorProps;
type TypeComponentChangePassword = (props: TypePropsChangePassword) => React.Element<*>;

//ChangePassword.js
//eslint-disable-next-line
function ChangePasswordP({
  t,
  passwordModel,
  history,
  emailModel,
}: TypePropsChangePassword & TranslatorProps & TypeWithEmailModel): React.Element<*> {
  return (
    <CentralForm>
      <form>
        <h1>{t('general:accounts.create_new_password')}</h1>
        <DoublePassword model={passwordModel} autoComplete="new-password" />
        <ElectroButton
          disabled={!passwordModel.passwordValid}
          onClick={async () => {
            const { email, token }: { email: string, token: string } = this.props.match.params;

            if (token && email) {
              try {
                await passwordModel.resetPassword(email, token);
                emailModel.email = email;
                history.push('/password-updated', { success: true });
              } catch (e) {
                history.push('/password-updated', { success: false, data: e });
                //todo: handle failure cases.
              }
            }
          }}
          label={t('general:actions.create')}
        />
      </form>
    </CentralForm>
  );
}

const ChangePassword: TypeComponentChangePassword = translate()(
  inject('emailModel', 'passwordModel')(observer(ChangePasswordP))
);

export default ChangePassword;
